import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import HelperBusiness from '../../helper/Business';
import { withTranslation } from "react-i18next";
import lang from 'i18next';



class HeaderClients extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      type: props.type ?? 'header',
      active: props.active ?? '',
    };
  }


  renderGroups() {
    if(HelperBusiness.getRoleIncl('trainer,admin')) {
      if(this.state.type === 'header') {
        return (
          <Link to={ROUTES.CLIENTSGROUPS} className={this.state.active === 'groups' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:clients.groups')}</p>
            <div className="bg"></div>
          </Link>
        )
      } else {
        return (
          <Link to={ROUTES.CLIENTSGROUPS} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:clients.groups')}</div>
          </Link>
        )
      }
    }
  }


  renderReport() {
    if(HelperBusiness.getRoleIncl('trainer,admin,finance,cs')) {
      if(this.state.type === 'header') {
        return (
          <Link to={ROUTES.CLIENTSREPORT} className={this.state.active === 'reports' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:clients.reports')}</p>
            <div className="bg"></div>
          </Link>
        )
      } else {
        return (
          <Link to={ROUTES.CLIENTSREPORT} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:clients.reports')}</div>
          </Link>
        )
      }
    }
  }


  render() {
    if(this.state.type === 'header') {
      return (
        <div>
          <Link to={ROUTES.CLIENTS} className={this.state.active === 'list' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:clients.list')}</p>
            <div className="bg"></div>
          </Link>
          {this.renderGroups()}
          {this.renderReport()}
        </div>
      )
    } else {
      return (
        <div>
          <Link to={ROUTES.CLIENTS} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:clients.list')}</div>
          </Link>
          {this.renderGroups()}
          {this.renderReport()}
        </div>
      )
    }
  }
}


export default withTranslation(['nav'])(HeaderClients);